// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__30VFd","active":"NavigationItem_active__jHCWa"};